<div class="picker-trigger" (click)="toggle($event)">
  <span>{{ formattedValue || placeholder }}</span>
  <svg-icon src="assets/device/chevron-down.svg" class="picker-chevron"></svg-icon>
</div>

@if (show) {
  <div class="calendar-dropdown" (click)="stopPropagation($event)">
    <div class="calendar-header">
      <button class="cal-nav cal-nav-prev" type="button" (click)="prevMonth()">
        <svg-icon src="assets/device/chevron-down.svg"></svg-icon>
      </button>
      <div class="cal-month-year">
        <select class="cal-select" [(ngModel)]="pickerMonth">
          @for (name of monthNames; track $index) {
            <option [ngValue]="$index">{{name | translate}}</option>
          }
        </select>
        <select class="cal-select" [(ngModel)]="pickerYear">
          @for (y of yearOptions; track y) {
            <option [ngValue]="y">{{y}}</option>
          }
        </select>
      </div>
      <button class="cal-nav cal-nav-next" type="button" (click)="nextMonth()">
        <svg-icon src="assets/device/chevron-down.svg"></svg-icon>
      </button>
    </div>

    <div class="calendar-weekdays">
      @for (wd of weekDays; track wd) {
        <span>{{wd | translate}}</span>
      }
    </div>

    <div class="calendar-grid">
      @for (cell of calendarDays; track cell.dateStr) {
        <button type="button" class="cal-day"
          [class.other-month]="!cell.currentMonth"
          [class.selected]="cell.dateStr === value"
          [class.past-date]="disablePastDates && isPastDate(cell.dateStr)"
          [disabled]="disablePastDates && isPastDate(cell.dateStr)"
          (click)="selectDate(cell.dateStr)">
          {{cell.day}}
        </button>
      }
    </div>
  </div>
}
